import React from 'react';
import { LayerGroup, useMapEvent } from 'react-leaflet';
import { useDispatch, useSelector } from 'react-redux';

import { useGame } from '../../context';
import { createDraft, toggleNavigation } from '../../redux/actions';
import MapMarker from './marker';
import MapDraftMarker from './marker-draft';
import MapEditableMarker from './marker-editable';
import useMarkers from './use-markers';

const MarkersLayerComponent = React.memo(() => {
  const dispatch = useDispatch();

  const done = useSelector(_ => _.done);
  const draft = useSelector(_ => _.draft);
  const filters = useSelector(_ => _.filters);
  const navigation = useSelector(_ => _.navigation);

  const { icons } = useGame();
  const { editmode, markers } = useMarkers();

  useMapEvent('click', ({ latlng }) => {
    if (editmode) {
      dispatch(createDraft(latlng));
    } else if (navigation) {
      dispatch(toggleNavigation(null));
    }
  });

  // console.log('render markers layer');

  return (
    <LayerGroup>
      {draft && <MapDraftMarker data={draft} />}
      {editmode &&
        markers.map(obj => {
          try {
            const { Icon, color } = icons[obj.category];
            return (
              <MapEditableMarker
                key={obj.id}
                background={color}
                data={obj}
                Icon={Icon}
              />
            );
          } catch (err) {
            // @TODO send err to fatality service
            // console.log('obj', obj);
            return null;
          }
        })}
      {!editmode &&
        markers
          .filter(obj => obj.region)
          .filter(obj => {
            const ishidden = filters.includes(obj.category);
            return !ishidden;
          })
          .filter(obj => {
            const isdone = done.includes(obj.id);
            const hidecompleted = filters.includes('completed') && isdone;
            return !hidecompleted;
          })
          .map(obj => {
            const { Icon, collectible, color } = icons[obj.category];
            const isdone = done.includes(obj.id);
            return (
              <MapMarker
                key={obj.id}
                background={color}
                collectible={collectible}
                completed={isdone}
                data={obj}
                Icon={Icon}
              />
            );
          })}
    </LayerGroup>
  );
});

MarkersLayerComponent.displayName = 'MarkersLayerComponent';

export default MarkersLayerComponent;
